import React from 'react';
import { SkeletonRect, SkeletonText, SkeletonPill, SkeletonButton } from '../../../common/Skeleton';

const LessonFormSkeleton = () => {
  return (
    <div className="space-y-4">
      {/* Title Input Skeleton */}
      <div>
        <div className="mb-2">
          <SkeletonText widths={['w-24']} height="h-4" />
        </div>
        <SkeletonRect width="w-full" height="h-10" rounded="md" />
      </div>

      {/* Content Editor Skeleton */}
      <div>
        <div className="mb-2">
          <SkeletonText widths={['w-32']} height="h-4" />
        </div>
        <SkeletonRect width="w-full" height="h-[500px]" rounded="md" />
      </div>

      {/* Experience Points Input Skeleton */}
      <div>
        <div className="mb-2">
          <SkeletonText widths={['w-40']} height="h-4" />
        </div>
        <SkeletonRect width="w-full" height="h-10" rounded="md" />
        <div className="mt-1">
          <SkeletonText widths={['w-64']} height="h-3" />
        </div>
      </div>

      {/* Tags Section Skeleton */}
      <div>
        <div className="mb-2">
          <SkeletonText widths={['w-16']} height="h-4" />
        </div>
        <div className="flex flex-wrap gap-2">
          <SkeletonPill width="w-20" height="h-8" />
          <SkeletonPill width="w-24" height="h-8" />
          <SkeletonPill width="w-16" height="h-8" />
        </div>
      </div>

      {/* Buttons Skeleton */}
      <div className="flex gap-3 mt-6">
        <SkeletonButton width="flex-1" height="h-10" rounded="md" />
        <SkeletonButton width="flex-1" height="h-10" rounded="md" />
      </div>
    </div>
  );
};

export default LessonFormSkeleton;
